export default __webpack_public_path__ + "static/Saira-SemiBold-bb46a6cc2714cd6dc3d5cd0a03ab57c6.woff2";